
/*
 * État de connexion de l'appareil
 */
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';
import capacitorReady from 'lib/capacitor-init';

const CONNECTION_NAMES = {
	'unknown': 'Inconnue',
	'ethernet': 'Ethernet',
	'wifi': 'WiFi',
	'2g': 'Mobile 2G',
	'3g': 'Mobile 3G',
	'4g': 'Mobile 4G',
	'5g': 'Mobile 5G',
	'cellular': 'Mobile',
	'none': 'Aucune',
};

export default Backbone.Model.extend({
	defaults: {
		online: false,
		type: null,
		name: ''
	},


	initialize: function()
	{
		// Events web standards (sur window, pas document comme sous Cordova)
		window.addEventListener( "offline", _.bind( this.update, this ) );
		window.addEventListener( "online", _.bind( this.update, this ) );

		if( !Capacitor.isNativePlatform() )
		{
			this.update();
		}

		capacitorReady.then( _.bind( function()
		{
			if( Capacitor.isNativePlatform() )
			{
				Network.addListener( 'networkStatusChange', _.bind( this.update, this ) );
			}
			this.update();
		}, this ) );
	},


	update: function()
	{
		var self = this;
		this._getStatus().then(function( status )
		{
			self.set({
				online: status.connected,
				type: status.connectionType,
				network: self._connectionName( status.connectionType ),
			});
			console.log( 'network', self.attributes );
		});
	},


	_getStatus: function()
	{
		if( Capacitor.isNativePlatform() )
		{
			return Network.getStatus();
		}

		var deferred = $.Deferred();
		deferred.resolve({
			connected: navigator.onLine !== false,
			connectionType: navigator.onLine ? 'wifi' : 'none',
		});
		return deferred.promise();
	},


	isOnline: function()
	{
		if( Capacitor.isNativePlatform() && this.has( 'online' ) )
		{
			return this.get( 'online' );
		}

		if( navigator.onLine !== undefined )
		{
			return navigator.onLine;
		}

		return true;
	},


	getConnectionType: function()
	{
		return this.get('type');
	},

	_connectionName: function( type )
	{
		if( !type ) return null;
		return CONNECTION_NAMES[ type ] || type;
	},

	getConnectionName: function()
	{
		return this.get('network');
	}

});
